import React, { useState, useEffect } from "react";
import { db } from "../../utils/firebase";
import { collection, getDocs, deleteDoc, doc, setDoc } from "firebase/firestore";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './UserArchive.css'; // Custom styles
import { Link, useLocation } from 'react-router-dom';

const UserArchive = () => {
  const [archivedUsers, setArchivedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Fetch archived users
  useEffect(() => {
    const fetchArchivedUsers = async () => {
      try {
        const archiveCollectionRef = collection(db, "user_archives");
        const snapshot = await getDocs(archiveCollectionRef);
        const users = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setArchivedUsers(users);
      } catch (error) {
        console.error("Error fetching archived users: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArchivedUsers();
  }, []);

  // Restore user to main Users collection
  const handleRestoreUser = async (user) => {
    try {
      const userDocRef = doc(db, "Users", user.id);
      await setDoc(userDocRef, user); // Add user back to Users collection
      await deleteDoc(doc(db, "user_archives", user.id)); // Remove user from Archives
      setArchivedUsers((prevUsers) => prevUsers.filter((u) => u.id !== user.id));
    } catch (error) {
      console.error("Error restoring user: ", error);
    }
  };

  // Permanently delete user
  const handleDeleteUser = async (userId) => {
    try {
      await deleteDoc(doc(db, "user_archives", userId)); // Delete user from Archives
      setArchivedUsers((prevUsers) => prevUsers.filter((u) => u.id !== userId));
    } catch (error) {
      console.error("Error deleting user: ", error);
    }
  };

  if (loading) return <p>Loading archived users...</p>;

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
      <div className="admin-sidebar">

           <h2>Admin Panel</h2>
           <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
           <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
           <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
           <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
           <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>
 
           <h2>Places to Visit</h2>
           <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
           <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
           <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
           <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>
 
           <h2>Things to Do</h2>
           <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
           <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
           <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>
 
           <h2>Archives</h2>
           <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
           <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
           <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
           <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
         </div>
        <div className="admin-content">
          <h2>Archived Users</h2>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Profile</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Birthday</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {archivedUsers.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <img src={user.profile_image} alt={`${user.firstName}'s profile`} />
                    </td>
                    <td>{`${user.firstName} ${user.lastName}`}</td>
                    <td>{user.email}</td>
                    <td>{user.gender || "N/A"}</td>
                    <td>{user.birthday || "N/A"}</td>
                    <td>
                    <button
                      className="restore-btn btn btn-success"
                      onClick={() => handleRestoreUser(user)}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button
                      className="delete-btn btn btn-danger"
                      onClick={() => handleDeleteUser(user.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserArchive;
